import { TableCell, TableRow } from "@mui/material";
import { useContext } from "react";
import { ActivePosition } from "src/types/products";

import Context from "../../context";
import cols from "./Cols";

export default function Row(props: ActivePosition) {
	const { state } = useContext(Context);
	return (
		<TableRow hover>
			{cols(props.currency, state.showType !== "NO_AGREGATED").map(({ Cell, align }, index) => (
				<TableCell align={align} key={index} width={"12.5%"}>
					<Cell {...props} />
				</TableCell>
			))}
		</TableRow>
	);
}
